var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resp-status"},[_c('ui-tag',{attrs:{"bgColor":_vm.resp.getStatusBgColor(),"color":_vm.resp.getStatusColor()}},[_vm._v("\n    "+_vm._s(_vm.resp.getStatusLabel())+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }